import { DatabaseCost, ServerCost } from '@amzn/awscat-portfolio-assessment-types';

import { constants } from '../../common/Localization';
import { formatCurrencyNoDecimals } from '../../common/LocalizationHelper';
import { ColumnDefinition, ColumnTypes } from '../../common/table/types';
import { getCell } from '../common/awsui-table-helper';

export const getDatabaseCostColumnDefinition = (currency: string): ColumnDefinition<DatabaseCost>[] => [
    {
        cell: item => item.databaseId,
        header: constants.DATABASE_ID,
        id: 'databaseId',
        type: ColumnTypes.TEXT
    },{
        data: item => item.AWS.computeCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.AWS.computeCost, currency)),
        header: constants.AWS_COMPUTE_COST,
        id: 'awsComputeCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.AWS.licenseCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.AWS.licenseCost, currency)),
        header: constants.AWS_DB_LICENSE,
        id: 'awsLicenseCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.AWS.storageCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.AWS.storageCost, currency)),
        header: constants.AWS_STORAGE_COST_TITLE,
        id: 'awsStorageCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.OnPremises.computeCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.OnPremises.computeCost, currency)),
        header: `${constants.ON_PREM} ${constants.COMPUTE_COST}`,
        id: 'onPremComputeCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.OnPremises.licenseCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.OnPremises.licenseCost, currency)),
        header: `${constants.ON_PREM} ${constants.LICENSE_COST}`,
        id: 'onPremLicenseCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.OnPremises.softwareCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.OnPremises.softwareCost, currency)),
        header: `${constants.ON_PREM} ${constants.SOFTWARE_COST}`,
        id: 'onPremSoftwareCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.OnPremises.storageCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.OnPremises.storageCost, currency)),
        header: `${constants.ON_PREM} ${constants.STORAGE_COST}`,
        id: 'onPremStorageCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.proportion?.toFixed(2),
        cell: item => item.proportion?.toFixed(2),
        header: constants.COST_PROPORTION,
        id: 'proportion',
        type: ColumnTypes.NUMBER
    },
];

export const getServerCostColumnDefinition = (currency: string): ColumnDefinition<ServerCost>[] => [
    {
        cell: item => item.serverId,
        header: constants.SERVER_ID,
        id: 'serverId',
        type: ColumnTypes.TEXT
    },{
        data: item => item.AWS.computeCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.AWS.computeCost, currency)),
        header: constants.AWS_COMPUTE_COST,
        id: 'awsComputeCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.AWS.osLicenseCost ?? 0,
        cell: item => getCell(formatCurrencyNoDecimals(item.AWS.osLicenseCost ?? 0, currency)),
        header: constants.OS_LICENSE,
        id: 'awsOSLicenseCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.AWS.storageCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.AWS.storageCost, currency)),
        header: constants.AWS_STORAGE_COST_TITLE,
        id: 'awsStorageCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.OnPremises.computeCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.OnPremises.computeCost, currency)),
        header: `${constants.ON_PREM} ${constants.COMPUTE_COST}`,
        id: 'onPremComputeCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.OnPremises.softwareCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.OnPremises.softwareCost, currency)),
        header:  `${constants.ON_PREM} ${constants.SOFTWARE_COST}`,
        id: 'onPremSoftwareCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.OnPremises.storageCost,
        cell: item => getCell(formatCurrencyNoDecimals(item.OnPremises.storageCost, currency)),
        header: `${constants.ON_PREM} ${constants.STORAGE_COST}`,
        id: 'onPremStorageCost',
        type: ColumnTypes.NUMBER
    },{
        data: item => item.proportion.toFixed(2),
        cell: item => item.proportion.toFixed(2),
        header: constants.COST_PROPORTION,
        id: 'proportion',
        type: ColumnTypes.NUMBER
    }
];
